import React from "react";

const AnswerMultiSelect = ({ values }) => {
  const list = Array.isArray(values) ? values.filter(Boolean) : [];
  if (list.length === 0) {
    return <p className="text-sm italic text-gray-400">No selections</p>;
  }
  return (
    <ul className="flex flex-wrap gap-1.5">
      {list.map((v, i) => (
        <li key={`${v}-${i}`}>
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-50 text-indigo-700 border border-indigo-200">
            {v}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default AnswerMultiSelect;
